<template>
  <div class="card border-0 card-with-shadow mb-primary">
    <div
      class="card-header bg-transparent p-primary d-flex justify-content-between align-items-center"
    >
      <h5 v-show="isDetailsEditable" class="card-title text-muted mb-0">
        {{ $t("details") }}
      </h5>
      <h5 v-show="!isDetailsEditable" class="card-title text-muted mb-0">
        {{ $t("edit_details") }}
      </h5>
      <div>
        <a
          href="#"
          v-show="!isDetailsEditable"
          class="text-muted"
          @click.prevent="showDetailsHide"
        >
          <app-icon stroke-width="1" name="x-square" />
        </a>
        <a
          href="#"
          v-show="!isDetailsEditable"
          class="text-muted"
          @click.prevent="showDetailsSave"
        >
          <app-icon stroke-width="1" name="check-square" />
        </a>

        <a
          href="#"
          v-if="dealOpen"
          v-show="isDetailsEditable"
          class="text-muted"
          @click.prevent="showDetailsEditable"
        >
          <app-icon stroke-width="1" name="edit" />
        </a>
      </div>
    </div>
    <div class="card-body">
      <div v-show="isDetailsEditable">
        <div class="form-group">
          <div class="form-row">
            <label class="mb-0 text-muted col-4 d-flex align-items-center">
              {{ $t("title") }}
            </label>
            <div class="col-8">
              {{ dealDetails.title }}
            </div>
          </div>
        </div>
		<div class="form-group">
          <div class="form-row" v-if="dealDetails.status">
            <label class="mb-0 text-muted col-4 d-flex align-items-center">
              {{ $t("sex") }}
            </label>
            <div class="col-8">
                <span v-if="dealDetails.sex_id == 1">Мужской</span>
				<span v-if="dealDetails.sex_id == 2">Женский</span>
            </div>
          </div>
        </div>
		<div class="form-group">
          <div class="form-row" v-if="dealDetails.status">
            <label class="mb-0 text-muted col-4 d-flex align-items-center">
              {{ $t("age") }}
            </label>
            <div class="col-8">
                <span v-if="dealDetails.age_id == 1">0-5</span>
				<span v-if="dealDetails.age_id == 2">5-16</span>
				<span v-if="dealDetails.age_id == 3">16-25</span>
				<span v-if="dealDetails.age_id == 4">25-40</span>
				<span v-if="dealDetails.age_id == 5">40-60</span>
				<span v-if="dealDetails.age_id == 6">Пенсионер</span>
            </div>
          </div>
        </div>

        <div class="form-group">
          <div class="form-row" v-if="dealDetails.status">
            <label class="mb-0 text-muted col-4 d-flex align-items-center">
              {{ $t("gid") }}
            </label>
            <div class="col-8">
                <span v-if="dealDetails.gid == 1">Без аудиогида</span>
				<span v-if="dealDetails.gid == 2">Русский</span>
				<span v-if="dealDetails.gid == 3">Украинский</span>
				<span v-if="dealDetails.gid == 4">Английский</span>
				<span v-if="dealDetails.gid == 5">Китайский</span>
            </div>
          </div>
        </div>
		<div class="form-group">
          <div class="form-row" v-if="dealDetails.status">
            <label class="mb-0 text-muted col-4 d-flex align-items-center">
              {{ $t("traf") }}
            </label>
            <div class="col-8">
                <span v-if="dealDetails.traf_id == 1">Рекомендация</span>
				<span v-if="dealDetails.traf_id == 2">Интернет</span>
				<span v-if="dealDetails.traf_id == 3">Facebook</span>
				<span v-if="dealDetails.traf_id == 4">Instagram</span>
            </div>
          </div>
        </div>
		<div class="form-group">
          <div class="form-row" v-if="dealDetails.status">
            <label class="mb-0 text-muted col-4 d-flex align-items-center">
              {{ $t("vis") }}
            </label>
            <div class="col-8">
                <span v-if="dealDetails.vis == 1">1-й раз</span>
				<span v-if="dealDetails.vis == 2">Постоянный</span>
            </div>
          </div>
        </div>
		<div class="form-group">
          <div class="form-row" v-if="dealDetails.status">
            <label class="mb-0 text-muted col-4 d-flex align-items-center">
              {{ $t("pay_id") }}
            </label>
            <div class="col-8">
                <span v-if="dealDetails.pay_id == 1">Наличиными</span>
				<span v-if="dealDetails.pay_id == 2">Картой</span>
				<span v-if="dealDetails.pay_id == 3">Онлайн</span>
            </div>
          </div>
        </div>
        
        <div class="form-group mb-0">
          <div class="form-row">
            <label class="mb-0 text-muted col-4 d-flex align-items-center">
              {{ $t("owner") }}
            </label>
            <div class="col-8" v-if="dealDetails.owner">
              <div class="d-flex align-items-center">
                <app-avatar
                  :title="dealDetails.owner.full_name"
                  class="mr-2"
                  :avatar-class="'avatars-w-30'"
                  :img="
                    dealDetails.owner.profile_picture
                      ? urlGenerator(dealDetails.owner.profile_picture.path)
                      : dealDetails.owner.profile_picture
                  "
                />
                <span>{{ dealDetails.owner.full_name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-show="!isDetailsEditable">
        <form ref="form">
          <div class="form-group">
            <div class="form-row">
              <label class="col-4 mb-0 d-flex align-items-center">{{
                $t("title")
              }}</label>
              <div class="col-8">
                <app-input type="text" v-model="dealDetails.title" />
              </div>
            </div>
          </div>

          <div class="form-group">
            <div class="form-row">
              <label class="col-4 mb-0 d-flex align-items-center">{{
                $t("expected_closing_date")
              }}</label>
              <div class="col-8">
                <app-input type="date" v-model="formData.expired_at" />
              </div>
            </div>
          </div>
          <div class="form-group mb-0">
            <div class="form-row">
              <label class="col-4 mb-0 d-flex align-items-center">{{
                $t("owner")
              }}</label>
              <div class="col-8" v-if="dealDetails.owner">
                <app-input
                  type="select"
                  list-value-field="full_name"
                  :list="ownerList"
                  v-model="dealDetails.owner_id"
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { FormMixin } from "@core/mixins/form/FormMixin.js";
import { formatDateToLocal, urlGenerator } from "@app/Helpers/helpers";

export default {
  name: "DealDetails",
  props: ["dealDetails", "statusList", "ownerList"],
  mixins: [FormMixin],
  data() {
    return {
      urlGenerator,
      isDetailsEditable: true,
      formData: {},
      formatDateToLocal,
    };
  },
  computed: {
    dealOpen() {
      return this.dealDetails.status.name == "status_open";
    }
  },
  methods: {
    showDetailsHide() {
      this.isDetailsEditable = true;
    },
    showDetailsSave() {
      this.formData.title = this.dealDetails.title;
	  this.formData.sex_id = this.dealDetails.sex_id;
	  this.formData.age_id = this.dealDetails.age_id;
	  this.formData.gid = this.dealDetails.gid;
	  this.formData.traf_id = this.dealDetails.traf_id;
	  this.formData.vis = this.dealDetails.vis;
	  this.formData.pay_id = this.dealDetails.pay_id;
      this.formData.expired_at = this.formData.expired_at ?
        moment(this.formData.expired_at).format("YYYY-MM-DD") :
        null;
      this.formData.owner_id = this.dealDetails.owner_id;
      this.submitFromFixin("PATCH", `crm/deals/${this.dealDetails.id}`, this.formData);
    },

    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.isDetailsEditable = true;
      this.$emit("update-request");
    },

    showDetailsEditable() {
      this.isDetailsEditable = false;
    },
  },
  mounted() {
    this.formData.expired_at = this.dealDetails.expired_at
      ? new Date(this.dealDetails.expired_at)
      : null;
  },
};
</script>
